<template>
    <div class="pairDetails">
        <transition enter-active-class="animated fadeIn"
                    leave-active-class="animated fadeOut">
            <div v-if="showPopup" class="openPopup" :style="{top:topPopup + 'px', right:rightPopup + 'px'}">
                <div class="openPopup__title">
                    <div class="openPopup__item">{{title}}</div>
                    <!--<div class="openPopup__item">
                        {{pairData.Count}}</div>-
                    <div class="openPopup__item">{{profitDeals}} ({{percentProfitDeals}}%)</div>
                    <div class="openPopup__item openPopup__item-balance"
                        :class="(twr < 0) ? 'color-red' : 'color-green'">$ {{twr}}</div>
                    <div class="openPopup__item openPopup__item-percent"
                        :class="(twr < 0) ? 'color-red' : 'color-green'">({{twr}}%)</div>
                    <div class="openPopup__item openPopup__item-percent"
                        :class="(profitPoints < 0) ? 'color-red' : 'color-green'">{{$moneyf(profitPoints,2)}} p</div>-->
                    <div class="openPopup__item openPopup__item-close icon-close" @click="closePopup"></div>
                </div>
                <div class="openPopup__wrap">
                    <div class="openPopup__data">
                        <div class="openPopup__data-equity">$ {{$moneyf(statistics.DailyRecords[statistics.DailyRecords.length - 1].EquityClose)}}</div>
                        <!--<div class="openPopup__data-profitPercent"
                            :class = "(deltaEquity < 0) ? 'color-red' : 'color-green'">{{$pricef(deltaEquity)}}%</div>-->
                    </div>
                    <simple-chart
                        :symbol="symbol"
                        :chartWidth = "350"
                        :chartHeight= "144">
                    </simple-chart>
                </div>
            </div>
        </transition>
        <div class="pairDetails-title">
            <div class="pairDetails-img">
                <img :src="require(`../../assets/img/${avatar}.png`)">
                {{title}}
            </div>
            <i @click="showChart($event)" class="icon-profit"></i>
        </div>
        <div class="pairDetails-row">
            <div class="pairDetails-item">
                <div class="pairDetails-itemText">Сделок всего</div>
                <div class="pairDetails-itemData">{{countDeals}}</div>
            </div>
            <div class="pairDetails-item">
                <div class="pairDetails-itemText">% успешных сделок</div>
                <div class="pairDetails-itemData">{{percentProfitDeals}}</div>
            </div>
        </div>
        <div class="pairDetails-row">
            <div class="pairDetails-item">
                <div class="pairDetails-itemText">Положительные</div>
                <div class="pairDetails-itemData">{{profitDeals}}</div>
            </div>
            <div class="pairDetails-item">
                <div class="pairDetails-itemText">Отрицательные</div>
                <div class="pairDetails-itemData">{{ddDeals}}</div>
            </div>
        </div>
        <div class="pairDetails-row">
            <div class="pairDetails-item">
                <div class="pairDetails-itemText">Прирост в %</div>
                <div class="pairDetails-itemData">{{twr}}</div>
            </div>
            <div class="pairDetails-item">
                <div class="pairDetails-itemText">Прирост в PIP</div>
                <div class="pairDetails-itemData">{{profitPoints}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import SimpleChart from "../profitability/sig-simple-chart"
export default {
    components: {
        "simple-chart":SimpleChart
    },
    data() {
        return {
            statistics:0,
            countDeals:0,
            profitDeals:0,
            twr:0,
            profitPoints:0,
            ddDeals:0,
            percentProfitDeals:0,
            showPopup:false,
            topPopup:0,
            rightPopup:10,
        }
    },
    props: {
        symbol:{default:'EURUSD'},
        title:{default:'EUR/USD'},
        avatar:{default:'GBP-USD'}
    },
    computed: {
        ...mapGetters({
              getStatistics: 'accountstat/getStatistics'
        })
    },
    methods: {
        updateChart() {
            let stat = this.getStatistics(this.symbol);
            if (!stat) {
                return;
            }
            this.statistics = stat;
            this.countDeals = this.statistics.Summary.TotalDeals;
            this.profitDeals = this.statistics.Summary.ProfitableDeals;
            this.ddDeals = this.countDeals - this.profitDeals;
            this.twr = this.statistics.Summary.Twr;
            this.profitPoints = this.statistics.Summary.ProfitPoints;
            this.percentProfitDeals = (100/(this.countDeals/this.profitDeals)).toFixed(2);
        },
        showChart(e) {
            this.showPopup = !this.showPopup;
            //if((screen.height - e.screenY) < 294)
            //this.topPopup = -254;
        },
        closePopup() {
            this.showPopup = false;
        }
    },
    created() {
        subscribeOnUpdate(this.$store, this.symbol, isFirstObtained => {
            //if (!this.symbol || !this.symbol.length) {
                this.updateChart(this.symbol);
            //}
        });
        // может быть, данные уже есть в store
        this.updateChart(this.symbol);
    } // created }
     
}
function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: symbol,
        callback: {
            id: `detail-pair-${symbol}`,
            handler: handler
        }
    });

}
</script>
<style lang="less" scoped>
.pairDetails {
    width: 360px;
    position: relative;
    border-bottom: 4px solid #293546;
    &-title {
        width: 100%;
        display: flex;
        align-items: center;
        height: 40px;
        justify-content: space-between;
        padding-left: 12px;
        padding-right: 12px;
        box-sizing: border-box;
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        i {
            color:#718DA8;
            cursor: pointer;
        }
    }
    &-row {
        display: flex;
        border-top: 1px solid #374B62;
    }
    &-item {
        flex-grow: 1;
        flex-basis: 50%;
        border-right: 1px solid #374B62;
        height: 60px;
        display: flex;
        justify-content: center;
        padding-left: 12px;
        flex-direction: column;
        &:last-child {
          border-right: none;  
        }
    }
    &-itemText {
        font-family: Arimo;
        font-size: 10px;
        font-weight: bold;
        color:#9FB6D2;
        text-transform: uppercase;
        margin-bottom: 6px;
    }
    &-itemData {
        font-family: Arimo;
        font-size: 16px;
        font-weight: bold;
        color:#fff;
    }
    &-img {
        img {
            width: 26px;
            height: 26px;
            margin-right: 6px;
        }
        display: flex;
        align-items: center;
    }
}
.openPopup {
    background-color: #3d536b;
    border-radius: 4px;
    width: 350px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    position:absolute;
    z-index: 1;
    &__data {
        position: absolute;
        padding-left: 12px;
        padding-top: 8px;
        &-equity {
            font-family: Arimo;
            font-size: 16px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1;
            letter-spacing: normal;
            color: #00ffd0;
        }
        &-profitPercent {
            font-family: Arimo;
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.54;
            letter-spacing: normal;
        }
    }
    &__title {
        display: flex;
        justify-content: flex-start;
        border-bottom: 1px solid #374b62;
    }
    &__item {
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.08;
        letter-spacing: 0.4px;
        text-align: left;
        color: #ffffff;
        margin-left: 12px;
        &-balance {
            color: #00ffd0;
        }
        &-percent {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #0fd7b7;
        }
        &-close {
            align-self: center;
            margin-left: auto;
            margin-right: 12px;
            color: #718da8;
            cursor: pointer;
            font-size: 24px;
            line-height: 1;
            &:hover {
               color: #fff; 
            }
        }
    }
    &__wrap {
        padding-top: 5px;
        position: relative;
    }
    &__hidden {
        visibility: hidden;
    }
}
</style>
